module.exports = __webpack_public_path__ + "img/21.9a04129f.png";